export type ImpersonationUser = {
  user_id: number;
  tenant_id: number;
  is_tenant_admin: boolean;
};

/**
 * Pick which user to impersonate for a tenant. When a userId is given, require
 * that exact user within the tenant (never fall back); otherwise use the first
 * tenant admin.
 *
 * The check is `userId !== undefined`, not a truthiness test: a requested user
 * must never silently become the tenant admin (that would impersonate a more
 * privileged, unintended account). A non-matching userId returns undefined so
 * the caller fails instead.
 *
 * Kept in its own dependency-free module so it can be unit tested without
 * pulling in the auth/jotai imports of SuperAdmin.utils.
 */
export const selectTenantUser = <T extends ImpersonationUser>(
  users: T[],
  tenant_id: number,
  userId?: number
): T | undefined =>
  userId !== undefined
    ? users.find((u) => u.tenant_id === tenant_id && u.user_id === userId)
    : users.find((u) => u.tenant_id === tenant_id && u.is_tenant_admin);
